import colors from "../../theme/Colours";
import { Button } from "@mui/material";
import { buttonStyle, buttonStyleSeller } from "./ActionButtonStyles";

type ActionButtonProps = {
  label: string;
  onClick: () => void;
  outlined?: boolean;
  isSellerPortal?: boolean;
  sx?: object;
  disabled?: boolean;
  startIcon?: React.ReactNode;
};

export const ActionButton = ({
  label,
  onClick,
  outlined = false,
  isSellerPortal,
  sx = {},
  disabled = false,
  startIcon,
}: ActionButtonProps) => {
  return (
    <Button
      sx={[
        isSellerPortal ? buttonStyleSeller : buttonStyle,
        outlined && {
          "&:hover": {
            color: colors.background2,
            borderColor: colors.primaryButtonOrangeHover,
            backgroundColor: colors.primaryButtonOrangeHover,
          },
          backgroundColor: colors.background2,
          color: colors.primaryButtonOrange,
          border: `1px solid ${colors.primaryButtonOrange}`,
        },
        sx,
      ]}
      variant={outlined ? "outlined" : "contained"}
      onClick={onClick}
      disabled={disabled}
      startIcon={startIcon}
    >
      {label}
    </Button>
  );
};
